module.exports = __webpack_public_path__ + "img/LINKEDIN.09706ce1.svg";